import { render, staticRenderFns } from "./EleFormCheckbox.vue?vue&type=template&id=96bd684e&"
import script from "./EleFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./EleFormCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports